var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tender-head-container" }, [
    _c("div", { staticClass: "tender-head clearfix" }, [
      _c(
        "div",
        { staticClass: "tender-head-info clearfix" },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showHeaderNavStrip,
                  expression: "showHeaderNavStrip",
                },
              ],
              staticClass: "tender-head-top",
            },
            [
              _vm.showHeaderNavStrip
                ? _c("HKLHeader", {
                    attrs: {
                      linkClassLeftPrimary: "back",
                      labelLeftPrimary: _vm.tenderHklLeftPrimaryLabel,
                      labelRightLeading: _vm.$t(
                        "listNavigation.previousRecord"
                      ),
                      labelRightTrailing: _vm.$t("listNavigation.nextRecord"),
                      navigationEntries: _vm.tenderListNavEntriesForHeader,
                      currentRecordId: _vm.$route.params.id,
                    },
                    on: {
                      "left-primary": _vm.onTenderHklLeftPrimary,
                      "right-leading": _vm.onTenderListNavEntry,
                      "right-trailing": _vm.onTenderListNavEntry,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("Lifecycle", {
            ref: "tenderLifecycle",
            attrs: {
              modalId: "tender-modules-lifecycle-modal",
              type: "tender",
              commentAttr: _vm.lifecycleCommentAttrs.rejectReason,
              histories: _vm.currentTenderHistory,
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "tender-info-with-status" }, [
            _c("div", { staticClass: "tender-info clearfix" }, [
              _c("div", { staticClass: "tender-project__number" }, [
                _vm._v(
                  "# " +
                    _vm._s(
                      _vm.tenderGeneral.prNumber !== 0
                        ? _vm.tenderGeneral.prNumber
                        : ""
                    )
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row no-margin-left" }, [
                _c(
                  "div",
                  { staticClass: "tender-project__name" },
                  [
                    _vm._v(_vm._s(_vm.tenderGeneral.prDescription || "")),
                    _c("TenderOptions"),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "clearfix" },
              [
                _vm._t("status", function () {
                  return [
                    _c(
                      "div",
                      {
                        class: _vm.statusStyle,
                        on: {
                          click: function ($event) {
                            return _vm.openLifecycleModal()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.statusText))]
                    ),
                  ]
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "float-right tender-view-button-bar clearfix",
                  },
                  [_vm._t("default")],
                  2
                ),
              ],
              2
            ),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }